// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetArticleDetailImageByIdRequestModel from '../../model/get-article-detail-image-by-id-request-model';
import GetArticleDetailImageByIdRequestDTO from '../dto/get-article-detail-image-by-id-request-dto';
import dtoSchema from '../schemas/get-article-detail-image-by-id-request-schema';

export default abstract class GetArticleDetailImageByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetArticleDetailImageByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetArticleDetailImageByIdRequestDTO>): GetArticleDetailImageByIdRequestModel;
  static toModel(dto: DeepPartial<GetArticleDetailImageByIdRequestDTO> | undefined | null): GetArticleDetailImageByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetArticleDetailImageByIdRequestDTO> | undefined | null): GetArticleDetailImageByIdRequestModel | undefined {
    return dto ? new GetArticleDetailImageByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetArticleDetailImageByIdRequestModel> | GetArticleDetailImageByIdRequestModel): GetArticleDetailImageByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetArticleDetailImageByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetArticleDetailImageByIdRequestModel, can not map to GetArticleDetailImageByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
